import RomanizationFormatter from "../romanization-formater";

const GermanCell = (props: any) => {
  const { item } = props;
  if (item.german) {
    console.log("Thi sis the item")
    return item.german;
  } else {
    if (item.link_on_type) {
      return (
        <>
          {item.link_on_type[1]}
          {" - "}
          <RomanizationFormatter
            inputString={item.lemma_id?.arabic_romanization}
          />
          {" - "}
          {item.lemma_id?.arabic}
        </>
      );
    } else {
      return (
        <>
          {"Wurzel: "}
          <RomanizationFormatter inputString={item.root?.romanization} />
          {" - "}
          {item.root?.root}
        </>
      );
    }
  }
};

export default GermanCell;
